var React = require('react');

function AppliancesCoffeeMachine (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m104.5 44.4999h-80v-8c0-6.627 5.373-12 12-12h56c6.627 0 12 5.373 12 12zm-4 60h-72c-2.209 0-4-1.791-4-4v-6h80v6c0 2.209-1.791 4-4 4zm-48-51.9999h24v-8h-24zm0-15h24v-6h-24zm4 23h16v-8h-16zm45-.0001h-17v-6h17c1.657 0 3 1.344 3 3 0 1.657-1.343 3-3 3zm-29-3h12m-24 3v4m8-4v4m-23-33h-12m12 6h-12m62-6h-12m12 6h-12m-35 34.4228c.166 6.45 2.411 12.186 5.877 16h20.247c3.466-3.814 5.71-9.55 5.876-16zm31.6201 4h4.025c2.209 0 4 1.791 4 4s-1.791 4-4 4c-.112 0-.222-.005-.333-.014h-6.38m-44.9321-39.4088v50m64-50v10m0 40v-34","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}));
}

AppliancesCoffeeMachine.defaultProps = {"height":"128","viewBox":"0 0 128 128","width":"128"};

module.exports = AppliancesCoffeeMachine;

AppliancesCoffeeMachine.default = AppliancesCoffeeMachine;
